import { MutableRefObject } from "react"
import { io, Socket } from "socket.io-client"

import { useAuthStore } from "@/modules/helpers/hooks/shared"
export const subscribeToChat = (
  socket: MutableRefObject<Socket | null>,
  callback: any,
  channelEmit: string | null,
  channelReceive: string | number,
  params?: object
) => {
  if (!socket.current) return

  const channelName = channelReceive?.toString()

  // Remove existing listeners for this channel to prevent duplicates
  if (channelName) {
    socket.current.removeAllListeners(channelName)
  }

  if (params && channelEmit) socket?.current.emit(channelEmit, params)

  // Add new listener
  socket?.current.on(channelName, (msg) => {
    return callback(null, msg)
  })
}

const API_HOST = import.meta.env.VITE_APP_API_HOST
const WS_HOST = `${API_HOST}`.replace("https://", "wss://")

export const initiateSocketConnection = async (
  socket: MutableRefObject<Socket | null>,
  data?: string | number
): Promise<boolean> => {
  const access_token = useAuthStore.getState().accessToken

  // Disconnect existing socket if present to allow reconnection
  if (socket.current) {
    socket.current.disconnect()
    socket.current = null
  }

  return new Promise((resolve, reject) => {
    const newSocket = io(WS_HOST, {
      extraHeaders: {
        Authorization: `Bearer ${access_token}`,
        data: data?.toString() || ""
      },
      transports: ["websocket"],
      query: { data },
      auth: { token: access_token },
      autoConnect: true
    })

    newSocket.on("connect", () => {
      console.log("Socket connected successfully")
      socket.current = newSocket
      resolve(true)
    })

    newSocket.on("connect_error", (error) => {
      console.error("Socket connection error:", error)
      reject(error)
    })

    newSocket.on("disconnect", () => {
      console.log("Socket disconnected")
    })
  })
}
export const disconnectSocket = (socket: MutableRefObject<Socket | null>) => {
  console.log("Disconnecting socket...")
  if (socket?.current) socket?.current.disconnect()
}

export const onEmit = (
  socket: MutableRefObject<Socket | null>,
  channelEmit: string,
  data: object
) => {
  if (!socket?.current) return

  socket?.current.timeout(24 * 60 * 60).emit(channelEmit, data)
}
